import {
  checkoutLineItemsAdd,
  checkoutCreate,
  checkoutLineItemsUpdate,
  checkoutCustomerDisassociateV2,
} from './mutations'
import { retreiveCheckout } from './queries'
export default class Checkout {
  constructor({ $axios, Shopify, app, error }) {
    this.$axios = $axios
    this.Shopify = Shopify
    this.app = app
    this.error = error
  }

  async create(lineItems) {
    try {
      const checkoutInput = {
        lineItems,
      }
      const body = JSON.stringify({
        query: checkoutCreate,
        variables: {
          input: checkoutInput,
        },
      })
      const {
        data: { data },
        errors,
      } = await this.$axios.post(this.Shopify.getUrl(), body, {
        headers: this.Shopify.getHeader(),
      })
      if (errors) throw new Error(errors)
      else return data.checkoutCreate
    } catch (e) {
      throw new Error(e)
    }
  }

  async addLineItems(checkoutId, lineItems) {
    try {
      const body = JSON.stringify({
        query: checkoutLineItemsAdd,
        variables: {
          checkoutId,
          lineItems,
        },
      })
      const {
        data: { data, errors },
      } = await this.$axios.post(this.Shopify.getUrl(), body, {
        headers: this.Shopify.getHeader(),
      })
      if (errors) throw new Error(errors)
      else return data.checkoutLineItemsAdd
    } catch (e) {
      throw new Error(e)
    }
  }

  async retreive(checkoutId) {
    try {
      const body = JSON.stringify({
        query: retreiveCheckout,
        variables: {
          id: checkoutId,
        },
      })
      const {
        data: {
          data: { node },
        },
      } = await this.$axios.post(this.Shopify.getUrl(), body, {
        headers: this.Shopify.getHeader(),
      })
      return node
    } catch (e) {
      throw new Error(e)
    }
  }

  async updateLineItems(checkoutId, lineItems) {
    try {
      const body = JSON.stringify({
        query: checkoutLineItemsUpdate,
        variables: {
          checkoutId,
          lineItems,
        },
      })
      const {
        data: { data },
        errors,
      } = await this.$axios.post(this.Shopify.getUrl(), body, {
        headers: this.Shopify.getHeader(),
      })
      if (errors) throw new Error(errors)
      else return data.checkoutLineItemsUpdate
    } catch (e) {
      throw new Error(e)
    }
  }

  async disassociateCheckout(checkoutId) {
    try {
      const body = JSON.stringify({
        query: checkoutCustomerDisassociateV2,
        variables: {
          checkoutId,
        },
      })
      const {
        data: { data },
        errors,
      } = await this.$axios.post(this.Shopify.getUrl(), body, {
        headers: this.Shopify.getHeader(),
      })
      if (errors) throw new Error(errors)
      else return data.checkoutCustomerDisassociateV2
    } catch (e) {
      throw new Error(e)
    }
  }
}
